<template>
    <div :key="keyD" class="raptors-group">
        <h2 class="title">{{$t('unit.title')}}</h2>
        <div class="fallback" v-if="salons.length === 0"><h2 class="title">{{$t('home.no-salons')}}</h2>
        </div>
        <div class="select-container" v-if="salons.length > 0 && loaded">
            <!--            <h4>Salony</h4>-->
            <span class="label">{{$t('unit.salons')}}:</span>
            <VueMultiselect :allow-empty="false" :close-on-select="true"
                            :deselectLabel="$t('multiselect.deselectLabel')" :multiple="false"
                            :options="salons"
                            :placeholder="$t('multiselect.placeholder')"
                            :selectLabel="$t('multiselect.selectLabel')"
                            :selectedLabel="$t('multiselect.selectedLabel')"
                            :show-labels="false"
                            label="name"
                            track-by="id"
                            v-if="salons.length >0"
                            v-model="selectedSalon"

            ></VueMultiselect>
            <div class="everything" v-else>
                <router-link :to="{name:'manage-salons'}">{{$t('unit.noSalons')}}</router-link>
            </div>

        </div>
        <div class="everything" v-if="salons.length > 0">
            <div class="select-container" v-if="loaded">
                <span class="label">{{$t('unit.entrances')}}</span>
                <VueMultiselect :close-on-select="false" :deselectLabel="$t('multiselect.deselectLabel')"
                                :multiple="true" :options="points"
                                :placeholder="$t('unit.entrances')"
                                :selectLabel="$t('multiselect.selectLabel')"
                                :selectedLabel="$t('multiselect.selectedLabel')"
                                label="name"
                                track-by="id"
                                v-if="points.length > 0"
                                v-model="selectedPoints"
                                :limit="15"
                                :limit-text=" count => `+ ${count}`"
                ></VueMultiselect>
                <div class="everything" v-else>
                    <router-link :to="{name: 'devices'}">{{$t('unit.noPoints')}}</router-link>
                </div>
            </div>
            <div class="select-container" v-if="loaded">
              <span class="label">{{$t('unit.ports')}} <span v-if="ports.length > 0">({{$t('unit.disclaimer')}})</span></span>
                <VueMultiselect :close-on-select="false" :deselectLabel="$t('multiselect.deselectLabel')"
                                :group-select="true" :multiple="true"
                                :options="ports"
                                :placeholder="$t('unit.ports')"
                                :selectLabel="$t('multiselect.selectLabel')"
                                :selectedLabel="$t('multiselect.selectedLabel')"
                                group-label="entry"
                                group-values="ports"
                                label="name"
                                track-by="id"
                                v-if="ports.length > 0"
                                v-model="selectedPorts"
                                :limit="15"
                                :limit-text=" count => `+ ${count}`"
                ></VueMultiselect>
                <div class="everything" v-else>
                    <router-link :to="{name: 'manage-salons'}">{{$t('unit.noPorts')}}</router-link>
                </div>
            </div>
            <div class="charts-container container"
                 v-if="selectedSalon && (selectedPorts.length > 0 || selectedPoints.length > 0)">
                <div class="top">
                    <h4>{{$t('general.entriesCount')}}</h4>
                </div>
                <div class="controls" v-if="loaded && loadedTable">
                    <div class="date-control">
                        <button :class="{active: selectedPredef === 'counters'}" @click="selectedPredef = 'counters'
                            startDate = dates.today.startDate
endDate = dates.today.endDate;
">
                            {{$t('general.today')}}
                        </button>
                        |
                        <button :class="{active: selectedPredef === 'countersYesterday'}"
                                @click="selectedPredef = 'countersYesterday'
                            startDate = dates.yesterday.startDate
endDate = dates.yesterday.endDate;
">{{$t('general.yesterday')}}
                        </button>
                        |
                        <button :class="{active: selectedPredef === 'countersWeek'}"
                                @click="selectedPredef = 'countersWeek'
                            startDate = dates.week.startDate
endDate = dates.week.endDate;

">{{$t('general.week')}}
                        </button>
                        |
                        <button :class="{active: selectedPredef === 'countersMonth'}"
                                @click="selectedPredef = 'countersMonth'
                            startDate = dates.month.startDate
endDate = dates.month.endDate;
">{{$t('general.month')}}
                        </button>
                        |
                        <div class="picker-container">
                            <span class="active">{{$t('general.from')}}:</span>
                            <md-datepicker @md-closed="selectedPredef='period'" md-immediately
                                           :md-disabled-dates="fromBlocker" v-model="startDate">

                            </md-datepicker>
                        </div>

                        <div class="picker-container">
                            <span class="active">{{$t('general.to')}}:</span>
                            <md-datepicker :md-disabled-dates="gateKeeper" @md-closed="selectedPredef='period'"
                                           md-immediately v-model="endDate"></md-datepicker>
                        </div>
                    </div>
                    <div :title="$t('general.printPDF')" @click="printCharts" class="link print"
                         v-if="loaded && loadedTable">
                        <img src="../../assets/images/print.svg">
                        <span>{{$t('general.printPDF')}}</span>
                    </div>
                    <button @click="downloadCSV" class="link download" v-if="loaded && loadedTable"><img
                            src="../../assets/images/download.svg"><span>{{$t('general.downloadCSV')}}</span>
                    </button>
                    <ChartSwitcher :currentState="state" @changeChart="changeChart"></ChartSwitcher>

                </div>
                <div :key="keyDate" class="charts" v-if="loaded">
                    <bar-chart :chart-data="chartData" :height="chartHeight"
                               :options="style" v-if="state===0 && predefinedChartData && loaded"></bar-chart>

                    <line-chart :chart-data="lineData" :height="320"
                                :options="lineStyle" v-if="state === 1 && loaded"></line-chart>
                </div>
                <Preloader v-if="!loaded"></Preloader>
            </div>

            <div class="table-container"
                 v-if="selectedSalon && (selectedPorts.length > 0 || selectedPoints.length > 0)">
                <div class="top" v-if="loadedTable">
                    <button
                            :class="{active: tableFilter === 'daysHoursPeriod'}"
                            @click="callTable('daysHoursPeriod')"
                    >
                        {{$t('general.daysHoursPeriod')}}
                    </button>
                    |
                    <button
                            :class="{active: tableFilter === 'weeksDaysPeriod'}"
                            @click="callTable('weeksDaysPeriod')"
                    >
                        {{$t('general.weeksDaysPeriod')}}
                    </button>
                    |
                    <button
                            :class="{active: tableFilter === 'monthsDaysPeriod'}"
                            @click="callTable('monthsDaysPeriod')"
                    >
                        {{$t('general.monthsDaysPeriod')}}
                    </button>
                </div>
                <CountsTable :data="newTable" :translatable="translatable" v-if="loadedTable"></CountsTable>
                <Preloader v-if="!loadedTable"></Preloader>
            </div>
        </div>
        <preloader v-if="!loaded && salons.length !==0"></preloader>
    </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect/src/Multiselect';
import JsonCSV from 'vue-json-csv';
import jsPDF from 'jspdf';
import LineChart from '@/components/charts/LineChart.js';
import BarChart from '@/components/charts/BarChart.js';
import Preloader from '@/components/helpers/Preloader';
import ChartSwitcher from '@/components/helpers/ChartSwitcher';
import 'vue-material/dist/vue-material.min.css';
import CountsTable from '@/components/helpers/CountsTable';
import { RepositoryFactory } from '@/api/RepositoryFactory';
import 'jspdf-autotable';
import XLSX from 'xlsx';

const DataRepository = RepositoryFactory.get('data');

export default {
  name: 'Unit',
  data() {
    return {
      keyDate: 0,
      barTrans: '',
      tableCSVData: [],
      CSVOrder: [],
      selectedSalon: {},
      selectedPoints: [],
      ports: [],
      points: [],
      selectedPorts: [],
      salons: [],
      lineData: {},
      linData: [],
      startDate: '2019-08-26',
      endDate: '2019-09-02',
      predefinedChartData: [],
      loaded: false,
      selectedPredef: 'counters',
      state: 0,
      barData: {},
      newTable: [],
      loadedTable: false,
      tableFilter: 'daysHoursPeriod',
      translatable: false,
      delimiter: this.$store.getters.delimiter,
      dates: {
        today: {
          startDate: '',
          endDate: '',
        },
        yesterday: {
          startDate: '',
          endDate: '',
        },
        week: {
          startDate: '',
          endDate: '',
        },
        month: {
          startDate: '',
          endDate: '',
        },
      },
      keyD: 0,
      today: '',
      gateKeeper: (date) => {
        const blockedDate = new Date(this.startDate);
        blockedDate.setHours(0, 0, 0);
        const today = new Date().setHours(0, 0, 0);
        if (date < blockedDate || date > today) {
          return true;
        }

        return false;
      },
      fromBlocker: (date) => {
        const today = new Date();
        if (date > today) {
          return true;
        }
        return false;
      },
    };
  },
  components: {
    CountsTable,
    ChartSwitcher,
    VueMultiselect,
    Preloader,
    BarChart,
    LineChart,
    JsonCSV,
  },
  async mounted() {
    this.$store.commit('set_api_call', true);
    this.loaded = false;
    this.$material.locale = {
      startYear: 1900,
      endYear: 2099,
      dateFormat: 'yyyy-MM-dd',
      firstDayOfAWeek: 0,
      days: this.$t('datepicker.days'),
      shortDays: this.$t('datepicker.shortDays'),
      shorterDays: this.$t('datepicker.shorterDays'),
      months: this.$t('datepicker.months'),
      shortMonths: this.$t('datepicker.shortMonths'),
      shorterMonths: this.$t('datepicker.shorterMonths'),

    };
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = today.getFullYear();
    const nextWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() + -7);
    const prevMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
    const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() + -1);
    this.today = `${yyyy}-${mm}-${dd}`;
    this.dates.today.startDate = this.today;
    this.dates.today.endDate = this.today;
    this.dates.month.endDate = this.today;
    this.dates.week.endDate = this.today;
    this.dates.week.startDate = `${nextWeek.getFullYear()}-${String(nextWeek.getMonth() + 1)
      .padStart(2, '0')}-${String(nextWeek.getDate())
      .padStart(2, '0')}`;
    /*  this.dates.month.startDate = `${prevMonth.getFullYear()}-${String(prevMonth.getMonth() + 1)
        .padStart(2, '0')}-${String(prevMonth.getDate())
        .padStart(2, '0')}`; */
    this.dates.month.startDate = `${yyyy}-${mm}-01`;
    this.dates.yesterday.startDate = `${yesterday.getFullYear()}-${String(yesterday.getMonth() + 1)
      .padStart(2, '0')}-${String(yesterday.getDate())
      .padStart(2, '0')}`;
    this.dates.yesterday.endDate = this.dates.yesterday.startDate;
    this.startDate = this.dates.today.startDate;
    this.endDate = this.dates.today.endDate;



    await this.updateOptions(this.$store.getters.selectedGroup.id);
    if (this.$route.params.id) {
      const salonId = this.$route.params.id;
      const salon = this.salons.find(x => x.id === parseInt(salonId));
      if (salon !== undefined) {
        this.selectedSalon = this.salons.find(x => x.id === parseInt(salonId));
      } else {
        this.selectedSalon = this.salons[0];
      }
    } else {
      this.selectedSalon = this.salons[0];
    }
    if (this.selectedSalon !== undefined) {
      this.updateSelects(this.selectedSalon);
      this.getTable('daysHoursPeriod');
      await this.getData();
      await this.getLineData(this.dates.today.startDate, this.dates.today.endDate);
    }
    this.loaded = true;
    this.loadedTable = true;
    this.$store.commit('set_api_call', false);
  },
  watch: {
    language() {
      if (this.loaded) {
        this.barTrans = this.$t('general.reportsTitles.titles.bar.1');
      }
    },
    group(newValue) {
      this.loaded = false;
      this.updateOptions(newValue).then(() => {
        this.selectedSalon = this.salons[0];
        this.updateSelects(this.selectedSalon);
      });
      this.loaded = true;
    },
    async selectedSalon(newValue) {
      if (this.loaded) {
        this.loaded = false;
        this.startDate = this.dates.today.startDate;
        this.endDate = this.dates.today.endDate;
        this.selectedPredef = 'counters';
        this.state = 0;
        this.updateSelects(newValue);
        await this.getData();
        this.getTable(this.tableFilter);
        this.getLineData(this.startDate, this.endDate);
        this.loaded = true;
      }
    },
    async selectedPorts(newValue) {
      if (this.loaded) {
        this.loaded = false;
        this.state = 0;
        await this.getData();
        await this.getPeriodData(this.startDate, this.endDate);
        this.getTable(this.tableFilter);
        this.getLineData(this.startDate, this.endDate);
        this.loaded = true;
      }
    },
    async selectedPoints(newValue) {
      if (this.loaded) {
        this.state = 0;
        this.loaded = false;
        this.updatePorts(newValue);
        await this.getData();
        await this.getPeriodData(this.startDate, this.endDate);
        this.getTable(this.tableFilter);
        this.getLineData(this.startDate, this.endDate);
        this.loaded = true;
      }
    },
    async startDate(newValue, oldValue) {
      this.keyDate += 1;
      if (this.loaded && (this.selectedPredef !== 'counters' && this.selectedPredef !== 'countersYesterday' && this.selectedPredef !== 'countersWeek' && this.selectedPredef !== 'countersMonth')) {
        this.loaded = false;
        const start = new Date(newValue);
        const end = new Date(this.endDate);
        if (start > end) {
          this.endDate = newValue;
        }
        await this.getPeriodData(newValue, this.endDate);
        this.loaded = true;
      }
      await this.getLineData(newValue, this.endDate);
      this.getTable(this.tableFilter);
    },
    async endDate(newValue, oldValue) {
      this.keyDate += 1;
      if (this.loaded && (this.selectedPredef !== 'counters' && this.selectedPredef !== 'countersYesterday' && this.selectedPredef !== 'countersWeek' && this.selectedPredef !== 'countersMonth')) {
        this.loaded = false;
        await this.getPeriodData(this.startDate, newValue);
        this.loaded = true;
      }
      await this.getLineData(this.startDate, newValue);
      this.getTable(this.tableFilter);
    },
  },
  computed: {
    chartHeight() {
      if (this.loaded) {
        const hypothetical = (this.chartData.labels.length * 85) + 150;
        if (hypothetical > 250) {
          return hypothetical;
        }
      }
      return 250;
    },
    language() {
      return this.$i18n.locale;
    },
    csvBarData() {
      if (this.loaded) {
        return this.barData[this.selectedPredef];
      }
      return [];
    },
    group() {
      return this.$store.getters.selectedGroup.id;
    },
    chartData() {
      if (this.loaded) {
        if (this.predefinedChartData[this.selectedPredef] !== undefined) {
          return this.predefinedChartData[this.selectedPredef];
        }
      }
      return {
        datasets: [],
        labels: ['loading'],
      };
    },
    lineStyle() {
      return {
        title: {
          display: true,
          text: `${this.$t('general.reportsTitles.titles.line.1') + this.startDate} - ${this.endDate}`,
        },
        height: 320,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('general.hour'),
            },
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('general.counts'),
            },
          }],
        },
      };
    },
    style() {
      return {
        maintainAspectRatio: false,
        title: {
          display: true,
          text: `${this.$t('general.reportsTitles.titles.bar.1') + this.startDate} - ${this.endDate}`,
        },
        layout: {
          padding: {
            left: 50,
            right: 50,
            top: 50,
            bottom: 50,
          },
        },
        scales:
          {
            xAxes: [{
              minBarLength: 2,
              gridLines: {
                offsetGridLines: true,
              },
              ticks: {
                beginAtZero: true,
                min: 0,
              },
            }],
            yAxes:
              [{
                yAxes: [{
                  barPercentage: 0.95,
                  categoryPercentage: 1.0,
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                  },
                },
                ],
              }],
          },
      };
    },
    styleObject() {
      return this.$store.getters.cssConfig;
    },
  },
  methods: {
    createCSV(response) {
      const csvdata = [];
      let translateKey = '';
      switch (this.tableFilter) {
        case 'daysHoursPeriod':
          translateKey = '';
          break;
        case 'monthsDaysPeriod':
          translateKey = 'general.months.';
          break;
        default:
          translateKey = '';
          break;
      }
      Object.keys(response.rows).forEach((value, index) => {
        let attachTable = [];
        let rowIndex = '';
        let shop = '';
        if (this.tableFilter === 'weeksDaysPeriod') {
          const translateObject = {};
          Object.keys(response.rows[value].countsData).forEach((v) => {
            translateObject[this.$t(`general.days.${v}`)] = response.rows[value].countsData[v];
          });
          attachTable = translateObject;
          rowIndex = value.split(' ')[0];
          shop = value.replace(value.split(' ')[0], '');
        } else if (this.tableFilter === 'monthsDaysPeriod') {
          const translatable = value.split(' ')[0];
          rowIndex = `${this.$t(`general.months.${translatable}`)}`;
          shop = value.replace(value.split(' ')[0], '');
          attachTable = response.rows[value].countsData;
        } else {
          attachTable = response.rows[value].countsData;
          rowIndex = value.split(' ')[0];
          shop = value.replace(value.split(' ')[0], '');
        }
        const dto = {
          [this.$t('csvHeaders.date')]: rowIndex,
          [this.$t('csvHeaders.shop')]: shop,
          [this.$t('csvHeaders.rowSummary')]: response.rows[value].rowSummary,
          [this.$t('csvHeaders.minTemp')]: response.rows[value].minTemp,
          [this.$t('csvHeaders.maxTemp')]: response.rows[value].maxTemp,
          ...attachTable,
        };
        this.CSVOrder = [
          ...[this.$t('csvHeaders.date'), this.$t('csvHeaders.shop')],
          ...Object.keys(attachTable),
          ...[this.$t('csvHeaders.minTemp'), this.$t('csvHeaders.maxTemp'), this.$t('csvHeaders.rowSummary')]];
        csvdata.push(dto);
      });
      this.tableCSVData = csvdata;
    },
    downloadCSV() {
      if (this.state === 0) {
        const wb = XLSX.utils.book_new();
        const tableSheet = XLSX.utils.json_to_sheet(this.tableCSVData, { header: this.CSVOrder });
        XLSX.utils.book_append_sheet(wb, tableSheet, this.$t('general.tableData'));
        Object.keys(this.barData).forEach((v) => {
          const sheet = XLSX.utils.json_to_sheet(this.barData[v]);
          XLSX.utils.book_append_sheet(wb, sheet, this.$t(`general.reportLabels.${v}`));
        });

        XLSX.writeFile(wb, 'barChart.xlsx');
      } else {
        const wb = XLSX.utils.book_new();
        const sheet = XLSX.utils.json_to_sheet(this.linData);
        XLSX.utils.book_append_sheet(wb, sheet, this.$t('general.reportLabels.period'));
        XLSX.writeFile(wb, 'lineChart.xlsx');
      }
    },
    callTable(type) {
      this.tableFilter = type;
      if (type === 'monthsDaysPeriod') {
        this.translatable = true;
      } else {
        this.translatable = false;
      }
      this.getTable(type);
    },
    changeChart() {
      if (this.state === 0) {
        this.state = 1;
      } else {
        this.state = 0;
      }
    },
    updatePorts(selectedPoints) {
      this.selectedPorts = [];
      this.ports = [];
      selectedPoints.forEach((v) => {
        if (v.ports.length > 0) {
          this.ports.push({
            entry: v.name,
            ports: v.ports,
          });
          v.ports.forEach((port) => {
            this.selectedPorts.push(port);
          });
        }
      });
    },
    async updateOptions(groupId) {
      const { token } = this.$store.getters;
      const retrievedData = await DataRepository.getUnitUnits(token, groupId);
      this.salons = retrievedData.shops;
    },
    updateSelects(selectedSalon) {
      this.points = selectedSalon.points;
      this.selectedPoints = selectedSalon.points;
      this.ports = [];
      this.selectedPorts = [];
      this.points.forEach((v) => {
        if (v.ports.length > 0) {
          this.ports.push({
            entry: v.name,
            ports: v.ports,
          });
          v.ports.forEach((port) => {
            this.selectedPorts.push(port);
          });
        }
      });
    },
    async getData() {
      if (this.selectedSalon && (this.selectedPorts.length > 0 || this.selectedPoints.length > 0)) {
        const query = {
          shops: [{
            id: this.selectedSalon.id,
            points: [],
          }],
        };
        this.selectedPoints.forEach((point) => {
          if (point.ports.length > 0) {
            const pointObject = {
              id: point.id,
              ports: [],
            };
            point.ports.forEach((port) => {
              if (this.selectedPorts.includes(port)) {
                pointObject.ports.push({ id: port.id });
              }
            });
            query.shops[0].points.push(pointObject);
          }
        });
        const datar = await DataRepository.getUnitPredefinedData(this.$store.getters.token, query);
        const dataCollection = {};
        Object.keys(datar).forEach((item) => {
          dataCollection[item] = {
            labels: [],
            datasets: [],
          };
          const dataset = {
            backgroundColor: `${this.styleObject.chartPrimaryColor}99`,
            data: [],
            label: this.$t('general.counts'),
          };
          const datakey = Object.keys(datar[item]);
          const { oneSum } = datar[item][datakey[0]];
          if (!oneSum) {
            dataset.label = this.$t('general.entries');
          }
          dataCollection[item].datasets.push(dataset);
          if (!oneSum) {
            dataCollection[item].datasets.push({
              label: this.$t('general.exits'),
              backgroundColor: `${this.styleObject.chartSecondaryColor}78`,
              data: [],
            });
          }
          const entries = [];
          const data = [];
          Object.keys(datar[item]).forEach((val) => {
            dataCollection[item].labels.push(val);
            dataCollection[item].datasets[0].data.push(datar[item][val].inSum);
            if (!oneSum) {
              dataCollection[item].datasets[1].data.push(datar[item][val].outSum);
            }
            entries.push(datar[item][val].inSum);
            data.push({
              [this.$t('csvHeaders.name')]: val,
              [this.$t('csvHeaders.entries')]: datar[item][val].inSum,
              [this.$t('csvHeaders.exits')]: datar[item][val].outSum,
            });
          });
          const color = entries.map(x => `${this.styleObject.chartPrimaryColor}99`);
          color[this.argMax(entries)] = 'red';
          const datac = {
            label: this.$t('general.counts'),
            backgroundColor: color,
            data: entries,
          };
          if (this.selectedPorts.length > 0) {
            datac.label = this.$t('general.entries');
          }
          dataCollection[item].datasets[0] = datac;
          this.barData[item] = JSON.parse(JSON.stringify(data));
        });
        this.predefinedChartData = dataCollection;
      }
    },
    argMax(array) {
      if (array.length > 0) {
        return array.map((x, i) => [x, i]).reduce((r, a) => (a[0] > r[0] ? a : r))[1];
      }
      return 0;
    },
    printCharts() {
      const font = require('@/styles/font.json');
      let canvasEle = [];
      if (this.state === 0) {
        canvasEle = document.getElementById('horizontalbar-chart');
      } else {
        canvasEle = document.getElementById('line-chart');
      }
      const imgData = canvasEle.toDataURL('image/jpg', 1.0);
      const doc = new jsPDF({
        orientation: 'landscape',
        compress: true,
      });
      doc.addFileToVFS('nunito.ttf', font.nunito);
      doc.addFont('nunito.ttf', 'nunito', 'normal');
      doc.setFont('nunito', 'normal');
      doc.setFontSize(12);
      // const logo = document.getElementById('logo').getElementsByTagName('img')[0].src;
      // const elem = document.getElementById('counts-table');
      // const res = doc.autoTableHtmlToJson(elem);
      doc.addImage(imgData, 'JPEG', 30, 20, 230, 100, '', 'FAST');
      // doc.addImage(logo, 126, 21);
      doc.autoTable({
        html: '#counts-table',
        startY: 100,
        styles: {
          font: 'nunito',
          fontStyle: 'normal',
          fontSize: 6,
          cellWidth: 3,
        },
        columnStyles: {
          0: {
            cellWidth: 5,
          },
          1: {
            cellWidth: 10,
          },
          25: { columnWidth: 5 },
          26: { columnWidth: 5 },
          27: { columnWidth: 5 },
          28: { columnWidth: 5 },
        },
      });
      doc.save();
    },
    getTable(type) {
      if (this.selectedSalon && (this.selectedPorts.length > 0 || this.selectedPoints.length > 0)) {
        this.loadedTable = false;
        const query = {
          shops: [{
            id: this.selectedSalon.id,
            points: [],
          }],
          dateFrom: this.startDate,
          dateTo: this.endDate,
        };
        this.selectedPoints.forEach((point) => {
          if (point.ports.length > 0) {
            const pointObject = {
              id: point.id,
              ports: [],
            };
            point.ports.forEach((port) => {
              if (this.selectedPorts.includes(port)) {
                pointObject.ports.push({ id: port.id });
              }
            });
            query.shops[0].points.push(pointObject);
          }
        });
        DataRepository.getUnitTableData(this.$store.getters.token, query, type).then((retrievedData) => {
          this.newTable = retrievedData;
          this.createCSV(this.newTable);
          this.loadedTable = true;
        });
      }
    },
    async getPeriodData(startDate, endDate) {
      if (this.selectedSalon && (this.selectedPorts.length > 0 || this.selectedPoints.length > 0)) {
        this.predefinedChartData.period = {};
        const query = {
          shops: [{
            id: this.selectedSalon.id,
            points: [],
          }],
          dateFrom: startDate,
          dateTo: endDate,
        };
        this.selectedPoints.forEach((point) => {
          if (point.ports.length > 0) {
            const pointObject = {
              id: point.id,
              ports: [],
            };
            point.ports.forEach((port) => {
              if (this.selectedPorts.includes(port)) {
                pointObject.ports.push({ id: port.id });
              }
            });
            query.shops[0].points.push(pointObject);
          }
        });
        const retrievedData = await DataRepository.getUnitPredefinedData(this.$store.getters.token, query);
        const
          dataCollection = {
            labels: [],
            datasets: [
              {
                label: this.$t('general.counts'),
                backgroundColor: `${this.styleObject.chartPrimaryColor}99`,
                data: [],
              },
            ],
          };
        const entries = [];
        const data = [];
        Object.keys(retrievedData.counters).forEach((val) => {
          dataCollection.labels.push(val);
          // dataCollection[item].datasets[0].data.push(retrievedData[item][val].inSum);
          if (retrievedData.counters[val].oneSum) {
            entries.push(retrievedData.counters[val].inSum);
          } else {
            dataCollection.datasets.push({
              data: [retrievedData.counters[val].outSum],
              label: this.$t('general.exits'),
              backgroundColor: `${this.styleObject.chartPrimaryColor}78`,
            });
            entries.push(retrievedData.counters[val].inSum);
          }

          data.push({
            [this.$t('csvHeaders.name')]: val,
            [this.$t('csvHeaders.entries')]: retrievedData.counters[val].inSum,
            [this.$t('csvHeaders.exits')]: retrievedData.counters[val].outSum,
          });
        });
        const color = entries.map(x => `${this.styleObject.chartPrimaryColor}99`);
        color[this.argMax(entries)] = 'red';

        dataCollection.datasets[0] = {
          label: this.$t('general.entries'),
          backgroundColor: color,
          data: entries,
        };
        this.predefinedChartData.period = dataCollection;
        this.barData.period = JSON.parse(JSON.stringify(data));
      }
    },
    async getLineData(startDate, endDate) {
      this.linData = [];
      const colorArray = ['#f63', '#ffb399', '#f3f', '#ff9', '#00b3e6',
        '#e6b333', '#3366e6', '#996', '#9f9', '#b34d4d',
        '#80b300', '#809900', '#e6b3b3', '#6680b3', '#66991a',
        '#ff99e6', '#ccff1a', '#ff1a66', '#e6331a', '#3fc',
        '#66994d', '#b366cc', '#4d8000', '#b33300', '#cc80cc',
        '#66664d', '#991aff', '#e666ff', '#4db3ff', '#1ab399',
        '#e666b3', '#33991a', '#c99', '#b3b31a', '#00e680',
        '#4d8066', '#809980', '#e6ff80', '#1aff33', '#993',
        '#ff3380', '#cc0', '#66e64d', '#4d80cc', '#9900b3',
        '#e64d66', '#4db380', '#ff4d4d', '#99e6e6', '#66f'];
      if (this.selectedSalon && (this.selectedPorts.length > 0 || this.selectedPoints.length > 0)) {
        this.loadedTable = false;
        const query = {
          shops: [{
            id: this.selectedSalon.id,
            points: [],
          }],
          dateFrom: startDate,
          dateTo: endDate,
        };
        this.selectedPoints.forEach((point) => {
          if (point.ports.length > 0) {
            const pointObject = {
              id: point.id,
              ports: [],
            };
            point.ports.forEach((port) => {
              if (this.selectedPorts.includes(port)) {
                pointObject.ports.push({ id: port.id });
              }
            });
            query.shops[0].points.push(pointObject);
          }
        });
        const retrievedData = await DataRepository.getLineChartUnit(this.$store.getters.token, query);
        const dataCollection = {
          labels: [],
          datasets: [],
        };
        Object.keys(retrievedData.rows[Object.keys(retrievedData.rows)[0]].countsData).forEach((val) => {
          dataCollection.labels[val] = val;
        });
        let k = 0;
        Object.keys(retrievedData.rows).forEach((val) => {
          // eslint-disable-next-line eqeqeq
          const currentSalon = val;
          if (currentSalon !== undefined) {
            const dataset = {
              label: currentSalon,
              data: [],
              borderColor: colorArray[k],
            };
            Object.keys(retrievedData.rows[val].countsData).forEach((value) => {
              dataset.data[value] = retrievedData.rows[val].countsData[value];
            });
            dataCollection.datasets.push(dataset);
            k += 1;
            if (k > colorArray.length - 1) {
              k = 0;
            }
            const flatData = {};
            flatData[this.$t('csvHeaders.name')] = currentSalon;
            dataset.data.forEach((w, key) => {
              flatData[key] = w;
            });
            this.linData.push(flatData);
          }
        });
        this.lineData = dataCollection;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
    a {
        text-decoration: none;
        font-weight: bold;

        &:visited {
            color: #002678;
        }
    }

    button {
        cursor: pointer;
        text-transform: capitalize;

        &:hover {
            color: $peacock-blue;
        }
    }

    .switcheroo {
        align-items: center;
        display: flex;

        img {
            padding: 20px;
        }
    }

    .raptors-group {
        /*width: 100%;*/
        padding-left: 40px;
        padding-right: 55px;
        @include media('<1026px') {
            padding: 0;
        }
    }

    .top {
        margin-bottom: 20px;

        button {
            margin: 10px;
        }
    }

    .table-container {
        overflow: auto;
        .top {
            margin-bottom: 20px;
            display: flex;
            padding: 25px;
            align-items: center;

            button {
                margin: 10px;
            }
        }
    }

    .charts-container, .table-container {
        background: white;
        border-radius: 5px;
        padding: 20px 0;
        margin-top: 50px;
        margin-bottom: 50px;

        .top {
            margin-bottom: 20px;
        }

        .controls {
            border-top: 1px solid #e5e5e5;
            border-bottom: 1px solid #e5e5e5;
            padding: 40px 50px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            @include media('<755px') {
                flex-direction: column;
            }
        }

        .charts {
            max-height: 405px;
            overflow-y: auto;
        }

    }

    .link {
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
            margin-right: 15px;
        }
    }

    h4 {
        font-size: rem(16px);
        font-weight: bold;
        // color: $baseTextColor;
        text-transform: uppercase;
        text-align: left;
        margin-left: 33px;
        margin-top: 0;
    }

    /* The switch - the box around the slider */
    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #9e9e9e;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: #002678;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #9e9e9e;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #9e9e9e;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }

    .date-control {
        /* color: #878a94; */
        font-size: rem(14px);
        font-weight: 900;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        @include media('<755px') {
            flex-direction: column;
        }

    }

    button {
        background: none;
        border: none;
        font-size: rem(14px);
        font-weight: 900;
        /* color: #878a94; */
        color: inherit;

    }

    .table {
        box-shadow: none;
    }

    .table-container {
        box-shadow: 0 5px 6px $baseShadow;
        overflow: auto;

        .top {
            button {
                text-transform: uppercase;
            }

            border-bottom: 1px solid #e5e5e5;
        }

        .tr {
            .td {
                padding: 13px;
            }

            &:first-child {
                .td {
                    border: none;
                    border-bottom: 1px solid $border-blue;
                    font-weight: bold;
                }
            }

            &:not(:last-child) {
                .td {
                    vertical-align: middle;
                    // border: 1px solid $border-gray;
                    border-bottom: 1px solid $border-gray;

                    &:first-child {
                        border-left: none;
                        border-right: 1px solid $border-gray;
                    }

                    &:nth-last-child(-n+4) {
                        border-right: none;
                        border-left: 1px solid $border-gray;

                    }

                    .weather-container {
                        display: flex;
                        justify-content: center;

                        img {
                            width: 45px;
                        }
                    }

                }
            }


            &:last-child {
                font-weight: bold;

                .td {
                    padding: 13px 0;
                    border-bottom: 1px solid $border-gray;

                    &:first-child, &:last-child {
                        border-right: 1px solid $border-gray;

                    }
                }
            }
        }
    }

    .link.download {
        font-weight: normal;

        > div {
            display: flex;
            align-items: center;
            cursor: pointer;
        }

        text-transform: capitalize;

        &:hover {
            color: $peacock-blue;
        }
    }

    .link.print {
        cursor: pointer;
        text-transform: capitalize;

        &:hover {
            color: $peacock-blue;
        }
    }

    .active {
        color: $peacock-blue;
    }

    .picker-container {
        padding-left: 15px;
        display: flex;
        align-items: center;
        color: $peacock-blue !important;

        input {
            color: $peacock-blue !important;
        }

    }

</style>
